import { LOOSE_CARGO_RESPONSIBILITIES } from '@chukua/common';
import { Form, Input, InputNumber, Select, Switch } from 'antd';
import { LOOSE_CARGO_RESPONSIBILITY_LABELS } from '../policies/loose-cargo-responsibility-labels';
import type { SpecialHandlingRequirement } from '../../../../reference-data/reference-data.api';

const { TextArea } = Input;

interface LooseCargoDetailFieldsProps {
  specialHandlingRequirements: SpecialHandlingRequirement[];
}

/** Every field of the loose cargo details form, kept out of LooseCargoDetailsForm to stay under the line limit — same split as ContainerDetailFields. */
export function LooseCargoDetailFields({ specialHandlingRequirements }: LooseCargoDetailFieldsProps) {
  return (
    <>
      <Form.Item name="commodity" label="Commodity" rules={[{ required: true, message: 'Enter the commodity' }]}>
        <Input />
      </Form.Item>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="weightKg" label="Weight (kg)">
          <InputNumber className="w-full" min={1} />
        </Form.Item>
        <Form.Item name="volumeM3" label="Volume (m³)">
          <InputNumber className="w-full" min={0.01} step={0.01} />
        </Form.Item>
      </div>
      <Form.Item name="packaging" label="Packaging">
        <Input />
      </Form.Item>
      <Form.Item name="handlingNotes" label="Handling notes">
        <TextArea rows={2} />
      </Form.Item>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="loadingResponsibility" label="Loading responsibility">
          <Select allowClear options={LOOSE_CARGO_RESPONSIBILITIES.map((r) => ({ value: r, label: LOOSE_CARGO_RESPONSIBILITY_LABELS[r] }))} />
        </Form.Item>
        <Form.Item name="offloadingResponsibility" label="Offloading responsibility">
          <Select allowClear options={LOOSE_CARGO_RESPONSIBILITIES.map((r) => ({ value: r, label: LOOSE_CARGO_RESPONSIBILITY_LABELS[r] }))} />
        </Form.Item>
      </div>
      <Form.Item name="customerProvidesLabour" label="Customer provides labour" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item name="specialHandlingRequirementCodes" label="Special handling requirements">
        <Select mode="multiple" options={specialHandlingRequirements.map((r) => ({ value: r.code, label: r.name }))} />
      </Form.Item>
      <Form.Item name="specialHandlingNotes" label="Special handling notes">
        <TextArea rows={2} />
      </Form.Item>
    </>
  );
}
